export const fryer = [
  {
    id: "1",
    name: "Hot Wings",
    "6pcsPrice": "300",
    "12pcsPrice": "600",
    "20pcsPrice": "",
    singlePcPrice: "",
    "5pcsPrice": "",
    "6Pcs": "6pcs",
    "12pcs": "12pcs",
    "20pcs": "",
    singlepc: "",
    "5pcs": "",
  },
  {
    id: "2",
    name: "Nuggets",
    "6pcsPrice": "300",
    "12pcsPrice": "600",
    "20pcsPrice": "",
    singlePcPrice: "",
    "5pcsPrice": "",
    "6Pcs": "6pcs",
    "12pcs": "12pcs",
    "20pcs": "",
    singlepc: "",
    "5pcs": "",
  },
  {
    id: "3",
    name: "Hot Shots",
    "6pcsPrice": "",
    "12pcsPrice": "",
    "20pcsPrice": "600",
    singlePcPrice: "",
    "5pcsPrice": "",
    "6Pcs": "",
    "12pcs": "",
    "20pcs": "20pcs",
    singlepc: "",
    "5pcs": "",
  },
  {
    id: "4",
    name: "Chicken Piece",
    "6pcsPrice": "",
    "12pcsPrice": "",
    "20pcsPrice": "",
    singlePcPrice: "250",
    "5pcsPrice": "1150",
    "6Pcs": "",
    "12pcs": "",
    "20pcs": "",
    singlepc: "Single pc",
    "5pcs": "5 pcs",
  },
  {
    id: "5",
    name: "Large Fries",
    "6pcsPrice": "",
    "12pcsPrice": "",
    "20pcsPrice": "",
    singlePcPrice: "250",
    "5pcsPrice": "",
    "6Pcs": "",
    "12pcs": "",
    "20pcs": "",
    singlepc: "",
    "5pcs": "",
  },
  {
    id: "6",
    name: "Family Fries",
    "6pcsPrice": "",
    "12pcsPrice": "",
    "20pcsPrice": "",
    singlePcPrice: "350",
    "5pcsPrice": "",
    "6Pcs": "",
    "12pcs": "",
    "20pcs": "",
    singlepc: "",
    "5pcs": "",
  },
  {
    id: "7",
    name: "Loaded Fries",
    "6pcsPrice": "",
    "12pcsPrice": "",
    "20pcsPrice": "",
    singlePcPrice: "840",
    "5pcsPrice": "",
    "6Pcs": "",
    "12pcs": "",
    "20pcs": "",
    singlepc: "",
    "5pcs": "",
  },
  {
    id: "8",
    name: "Mayo Garlic Fries",
    "6pcsPrice": "",
    "12pcsPrice": "",
    "20pcsPrice": "",
    singlePcPrice: "400",
    "5pcsPrice": "",
    "6Pcs": "",
    "12pcs": "",
    "20pcs": "",
    singlepc: "",
    "5pcs": "",
  },
  {
    id: "9",
    name: "Masala Fries",
    "6pcsPrice": "",
    "12pcsPrice": "",
    "20pcsPrice": "",
    singlePcPrice: "380",
    "5pcsPrice": "",
    "6Pcs": "",
    "12pcs": "",
    "20pcs": "",
    singlepc: "",
    "5pcs": "",
  },
];
